import * as React from "react";
import { Box, Tooltip, TooltipProps, makeStyles } from "@material-ui/core";
import { themeVariables } from "../_Theme";
import * as styles from "./styles.scss";

import { SvgIcon } from "../../../../components";

interface IProps {
  type: string;
  bgColor: string;
}

export const MUICourseGroupDefaultIcon = (props: IProps) => {
  const classes = makeStyles(() => ({
    iconBox: {
      backgroundColor: props.bgColor,
      borderRadius: themeVariables.shape.borderRadius,
    },
  }))();

  return (
    <Box className={`${classes.iconBox} ${styles.iconBox}`}>
      <SvgIcon type={props.type} />
    </Box>
  );
};
